import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'inbox-sticky-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, MatCardModule, MatButtonModule, TranslateModule],
  templateUrl: './sticky-footer.component.html',
  styleUrls: ['./sticky-footer.component.scss'],
})
export class StickyFooterComponent {
  @Output() public submitClick = new EventEmitter<void>();
  @Input() public cancelLink: string;
  @Input() public disabled = false;
  @Input() public submitOverride?: string;
  @Input() public cancelOverride?: string;

  onSubmit(): void {
    this.submitClick.emit();
  }
}
